import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { META, SHOW_INSIDE_PAGES } from './data/teater';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'sv';
    document.title = META.title;
    setMeta('name', 'description', META.description);
    setMeta('property', 'og:title', META.ogTitle);
    setMeta('property', 'og:description', META.ogDescription);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:locale', 'sv_SE');
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3dlnu6g324zya">
      <div lang="sv" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3dii530ufhy2k">
        <CountdownBar data-id="element-2" data-mp="nxn53r85d1mu" />
        <main data-id="element-3" data-mp="sudl6ejybx89">
          <Hero data-id="element-4" data-mp="su42lc18kscl" />
          <StatsBar data-id="element-5" data-mp="stkok6epio3u" />
          <Difference data-id="element-6" data-mp="ssspumptca9c" />
          <Recognize data-id="element-7" data-mp="swgmvvugvest" />
          <WhatsInside data-id="element-8" data-mp="3688rpx40wyp" />
          {SHOW_INSIDE_PAGES && <InsidePages data-id="element-9" data-mp="34x29ica5b3w" />}
          <Bonuses data-id="element-10" data-mp="38b6yx8f1wei" />
          <HowItWorks data-id="element-11" data-mp="3ud1f186rfma3" />
          <Audience data-id="element-12" data-mp="3ubrfsfo6881v" />
          <Offer data-id="element-13" data-mp="3uc9j1w993mja" />
          <Guarantee data-id="element-14" data-mp="3uevpttobhy0g" />
          <Testimonials data-id="element-15" data-mp="d4o0nv3yoa99" />
          <Faq data-id="element-16" data-mp="d4xr1jsx4jfh" />
          <FinalCta data-id="element-17" data-mp="d3cvbquvaug1" />
        </main>
        <Footer data-id="element-18" data-mp="d2bibguajxvo" />
      </div>
    </MotionConfig>;
}